module.exports = __webpack_public_path__ + "img/3-4.6a781cb6.jpg";